import axios from "axios";

export default {
    namespaced: true,
    state: {
        parts:[],
        part_info:{}
    },
    getters:{
        parts(state){
            return state.parts
        },
        part_info(state){
            return state.part_info
        }
    },  
    mutations:{
        SET_PARTS_LIST (state, payload) {
            state.parts = payload
        },
        SET_PARTS_INFO (state, payload) {
            state.part_info = payload
        }
    },
    actions:{
       async getPartsList(context,param){
        const response = await axios.get('/api/parts',{
            headers:{
              'Authorization':`Bearer ${param.token}`,
              "Access-Control-Allow-Headers": "*",
               "Access-Control-Allow-Method" : "*",
               "Access-Control-Allow-Origin": "*",
               "Access-Control-Allow-Credentials": "*",
            }
          });

            if(response.status == 200){

                context.commit('SET_PARTS_LIST',response.data.data)
            }
       }
    }
}